export enum CacheNameEnum {
    Search = 'search',
}
